"use client";
import { short as i } from "../common-words/short.js";
import { lowercase as s } from "../common-words/lowercase.js";
import { long as a } from "../common-words/long.js";
function o(n) {
  return `\\b${n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\b`;
}
function u(n, r, t, e = !1) {
  return e && new RegExp(`^${t}\\b`, "i").test(n) ? n : n.replace(new RegExp(t, "gi"), r);
}
function g(n) {
  let r = n;
  return r = s.reduce((t, e) => {
    const c = o(e);
    return u(t, e, c, !0);
  }, r), r = a.reduce((t, e) => {
    const c = o(e);
    return u(t, e, c);
  }, r), r = i.reduce((t, e) => {
    const c = o(e);
    return u(t, e, c);
  }, r), r;
}
export {
  g as transformCommonWords
};
